import React from 'react';
import { Box, Typography, Checkbox, Stack, Divider, Chip } from '@mui/material';
import { ToCItemData } from './ToCItem';
import { translate as t } from 'hooks/useTranslations';

interface ToCDrawerProps {
  selectedItems: ToCItemData[];
  onToggle: (id: string) => void;
  disabled?: boolean;
}

const ToCDrawer: React.FC<ToCDrawerProps> = ({ selectedItems, onToggle, disabled = false }) => {

  if (selectedItems.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant='body2' color='text.secondary'>
          {t('groups.manuals.exclusions.noItemsSelected')}
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={0} divider={<Divider />}>
      {selectedItems.map((item) => (
        <Box
          key={item.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 1.5,
            px: 2,
            height: 80,
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
        >
          <Checkbox checked={true} onChange={() => onToggle(item.id)} disabled={disabled} sx={{ mr: 1 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant='body2' sx={{ fontWeight: 500 }}>
              {item.title}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  );
};

export default ToCDrawer;